import styled from 'styled-components';
import background from '../../assets/checking-year/gradient-bd.svg'
import backgroundOverlay from '../../assets/checking-year/BD-LOGO.svg'
import { colors } from "../../utils/colors";

export const Background = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(${background});
    background-repeat: no-repeat;
    background-size: cover;
`;

export const BackgroundOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(${backgroundOverlay});
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

export const Logo = styled.img`
    width: 50%;
    max-width: 300px;
    margin-bottom: 30px;

    @media (max-width: 800px) {
        width: 80%;
    }
`;

export const Title = styled.h1`
    color: ${colors.CREAM};
    font-family: 'Markazi Text', serif;
    text-transform: uppercase;
    text-align: center;
    max-width: 90%;
    margin-bottom: 10px;
`;

export const Subtitle = styled.p`
    color: ${(props) => props.blue ? colors.DARK_BLUE : colors.CREAM};
    font-family: 'Courgette', cursive;
    margin-bottom: 30px;
    text-align: center;
    max-width: 90%;
`;

export const YearsInput = styled.input`
    background-color: ${colors.DARK_BLUE};
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 20px;
    border: solid 3px ${colors.CREAM};
    border-radius: 15px;
    outline: none;
    color: ${colors.CREAM};
    margin-bottom: 10px;
    font-size: 18px;
    -moz-appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;

export const YearsButton = styled.button`
    background-color: ${(props) => props.red ? colors.RED : colors.GREEN};
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 20px;
    border: solid 3px ${colors.CREAM};
    border-radius: 15px;
    outline: none;
    color: ${colors.WHITE};
    margin-bottom: 10px;
    font-size: 18px;
    -moz-appearance: textfield;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    cursor: pointer;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    @media (max-width: 800px) {
        width: 100%;
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;

    @media (max-width: 800px) {
        flex-direction: column;
        width: 90%;
        margin: 0 auto;
    }
`;

export const LanguageWrapper = styled.div`
    position: absolute;
    top: 50px;
    right: 50px;

    @media (max-width: 400px) {
        top: 25px;
        right: 25px;
    }
`;

export const OverlayPopup = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #272727B5;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Popup = styled.div`
    position: relative;
    background-color: ${colors.BLUE};
    height: 300px;
    max-width: 500px;
    width: 90%;
    margin: 0 auto;
    border: 5px solid ${colors.CREAM};
    border-radius: 15px;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: ${colors.WHITE};
    padding: 0 20px;

    @media (max-width: 400px) {
        height: 350px;
    }
`;
